import { useCallback, useMemo } from 'react';
import { scrollToElement } from '../../lib/userFunctions';
import { Loading } from 'app/components/Loading';
import ErrorMessageBox from 'app/components/ErrorMessageBox';
import { useParams } from 'react-router-dom';
import { POLICY_TYPE_NAME } from 'lib/const';
import moment from 'moment';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';

export const PolicyList = ({activeId=0, onChange=f=>f})=>{
	const { type } = useParams();

	const { data:policyList, isLoading, isError, error} = useQuery({
		queryKey:['policy/list', type],
		queryFn:()=>Api.get(`/api/policy/${type}/list`),
		staleTime:1000 * 60 * 60,
        gcTime:1000 * 60 * 60,
	})
	
	const onChangePolicy = useCallback((id)=>{
		if(id!==activeId) onChange(id);
		scrollToElement();
	}, [activeId, onChange]);

    
    const policyListContent = useMemo(() => {
        if(isLoading) return <li><Loading /></li>;
        if(isError) return <li>< ErrorMessageBox message={createFetchErrorMessage(error).message} /></li>;
        return policyList?.data?.map((item, key)=>{
			const activeClass = ( (activeId===0 && key===0) || item.id===activeId)?.id?'active':'';
			return (
				<li key={item.id} className={`${activeClass}`}>
					<button onClick={e=>onChangePolicy(item.id)}>
						{POLICY_TYPE_NAME[item.type]} 
						({moment(item.createdAt).format('YYYY.MM.DD')} ~ {item.expiredAt===null?'현재':moment(item.expiredAt).format('YYYY.MM.DD')})
					</button>
				</li>
			);
		})
    }, [isLoading, isError, error, policyList, activeId, onChangePolicy]);
	if(policyList?.data?.length===0)return null;
	
	return (
		<div className="policyList">
			<ul className="inner">
				{policyListContent}
			</ul>
		</div>
	);
};